module.exports = __webpack_public_path__ + "img/avatar1.6f9e42d0.png";